// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { exclamationMark16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-exclamation-mark': IconExclamationMark;
    }
}

/**
 * The icon component for the 'exclamationMark' icon
 */
export class IconExclamationMark extends IconSvg {
    public constructor() {
        super(exclamationMark16X16);
    }
}

registerIconSvg('icon-exclamation-mark', IconExclamationMark);
export const iconExclamationMarkTag = 'nimble-icon-exclamation-mark';
